import React, { HTMLProps } from 'react';
import { useTranslation } from 'react-i18next';
import { Cocktail } from './Cocktail';
import { ProgressButtons } from './ProgressButtons';
import { useWindowBreakpoints } from '../../../hooks/useWindowBreakpoints';

export const CocktailWrapperScreen: React.FC<
    { page: number; title?: string; subTitle?: string, isColorGoal?: boolean, isResultsScreen?: boolean} & HTMLProps<HTMLDivElement>
> = ({ page, title, subTitle, isColorGoal, children, isResultsScreen=false}) => {
    const { t } = useTranslation('pension');
    const breakpoints = useWindowBreakpoints();

    return (
        <div className="flex flex-row flex-wrap gap-2 xl:gap-4 justify-between items-stretch xl:items-start xl:m-8">
            {isResultsScreen && breakpoints.isWindowSmallerThan('md') && <Cocktail isColorGoal={isColorGoal} className="mb-12" />}
            <div className="m-4 xl:m-0 md:w-2/5">
                <ProgressButtons page={page} className="mb-12" />
                {title && (
                    <h1 className="text-bnd-black-1 dark:text-white text-3xl font-bold mb-4">
                        <span className="block text-sm text-bnd-blue">
                            {t('pension-cocktail-fill-screen-step') + page}
                        </span>
                        <span className="font-black text-xxl mb-4">{title}</span>
                    </h1>
                )}
                {subTitle && (
                    <p className="mb-4 text-gray-800">
                        {subTitle}
                    </p>
                )}
                {children}
            </div>
            {isResultsScreen
                ? breakpoints.isWindowBiggerThan('md') && <Cocktail isColorGoal={isColorGoal} />
                : breakpoints.isWindowBiggerThan('md') && <Cocktail isColorGoal={isColorGoal} />}
        </div>
    );
};
